import type { GetPracticeMemberPreferencesOutput } from '../model/practice-member.types';

export function isFirstDictationPending(
    preferences: GetPracticeMemberPreferencesOutput | null | undefined,
): boolean {
    const welcomeGuide = preferences?.['welcome-guide'];

    // An absent guide is not pending: the record expires 15 days after sign-up, so a long-standing
    // account has none.
    if (!welcomeGuide) {
        return false;
    }

    return !welcomeGuide.completedTasks.includes('dictate-recap');
}
